import { ProjectTriangle } from '../FilterTable/components/ProjectTriangle'
import { Subtitle } from '../subtitle/subtitle'
import './SectionHeader.scss'

export interface ISectionHeader {
  title: string
  description: string
  inLine?: boolean
  maxWidth: string
}

export const SectionHeader = ({
  title,
  description,
  inLine = false,
  maxWidth,
}: ISectionHeader) => {
  return (
    <div>
      <Subtitle text={title} style={{ border: 'none', marginTop: 0, marginBottom: "50px" }} />
      {description && (
        <div style={{ display: 'flex', gap: '10px' }}>
          <ProjectTriangle size={10} fill="#00A6FC" direction="right" />
          <p style={{ marginTop: 0, fontSize: '20px', lineHeight: '1.3' }}>{description}</p>
        </div>
      )}
    </div>
  )
}
